import type { MarketCountryCode } from '@backmarket/http-api'

import type { MarketShippingMethod } from './ShippingLegacy.types'
import { DEFAULT_INITIAL_VALUES } from './components/Form/Form.constants'
import type { FormValues } from './components/Form/Form.types'

export function toFormValues(
  marketShippingMehod: MarketShippingMethod,
  market: MarketCountryCode,
): FormValues {
  return {
    ...DEFAULT_INITIAL_VALUES,
    market,
    id: marketShippingMehod.id.toString(),
    carrierId: marketShippingMehod.carrier.id.toString(),
    categoryId: marketShippingMehod.category?.id?.toString() || '',
    cost: marketShippingMehod.cost,
    shippingDelay: marketShippingMehod.shippingDelay?.toString(),
  }
}
